module.exports = __webpack_public_path__ + "img/akimov.a459575d.jpg";